import template from "lodash/template";

export function render(templateName, data, settings = {
  'interpolate': /##([\s\S]+?)##/g,
  'variable': 'data'
}) {
  const tmpl = document.getElementById(templateName);
  const tmplString = tmpl.innerHTML;
  const t = template(tmplString, settings);
  return t(data);
}
